export function DriverAppIcon() {
  return (
    <svg
      width='54'
      height='54'
      viewBox='0 0 54 54'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M51 27C51 13.7452 40.2548 3 27 3C13.7452 3 3 13.7452 3 27C3 40.2548 13.7452 51 27 51C40.2548 51 51 40.2548 51 27Z'
        fill='#DAE4FF'
      />
      <rect
        x='18'
        y='12'
        width='17.8638'
        height='29.3477'
        rx='3'
        stroke='#382AFF'
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.7422 15.1899H30.1221'
        stroke='#382AFF'
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle
        cx='26.9335'
        cy='35.6059'
        r='1.91398'
        stroke='#382AFF'
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
